﻿<template>
  <div>
    <section class="small-12 medium-12 large-6 columns">
      <h1 v-html="vueModel.ContentViewModel.Step3ContentTravel.StepTitle" />

      <article>
        <h3
          v-html="vueModel.ContentViewModel.Step3ContentTravel.TitleClaimEventDescriptionForTravel"
        />
        <p v-html="vueModel.ContentViewModel.Step3ContentTravel.SubTextClaimEventDescription" />
        <div class="control push-up">
          <fieldset class="checkbox-inline checkbox-inline-text-inputs">
            <div v-for="(item, index) in damagedItems" :key="'damaged-item-' + index" class="row">
              <div class="small-7 medium-8 columns">
                <input :id="'checkbox-' + index" v-model="item.Active" type="checkbox" />
                <label :for="'checkbox-' + index" @click="toggleField(index)"><span class="title" v-html="item.Title" />{{ item.ExtraText }}</label>
              </div>
              <div class="small-4 small-offset-1 medium-offset-0 medium-4 columns">
                <span
                  v-show="(item.Active && !item.Editable) || item.Editable"
                  class="label"
                  v-html="vueModel.ContentViewModel.Step3ContentTravel.PlaceholderTextDamagedItem"
                />
                <input
                  v-show="item.Active && !item.Editable"
                  :id="'damaged-item-display-' + index"
                  v-model="item.DisplayValue"
                  type="text"
                  :tabindex="index + 1"
                  @focus="editDamagedItemValue(index)"
                />
                <Field
                  v-slot="{ field }"
                  v-model="item.Value"
                  :rules="{ required: item.Active, integer: true }"
                  :name="'damaged-item-value-' + index"
                  :label="vueModel.ContentViewModel.Step3ContentTravel.ErrorMessageDamagedItem"
                >
                  <input
                    v-bind="field"
                    v-show="item.Editable"
                    :id="'damaged-item-value-' + index"
                    type="text"
                    :tabindex="index + 1"
                    @blur="updateDisplayValue(index)"
                    @keyup.enter="updateDisplayValue(index)"
                  />
                  <ValidationError :name="'damaged-item-value-' + index" />
                </Field>
              </div>
            </div>
          </fieldset>
        </div>
      </article>
    </section>
  </div>
</template>
<script>
import ReportClaimMixin from '../ReportClaimMixin.vue';

export default {
  name: 'ReportClaimContentTravelStep3',
  mixins: [ReportClaimMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep3Model
    };
  },
  computed: {
    damagedItems() {
      return this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems;
    }
  },
  mounted() {
    for (var i in this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems) {
      if (this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems[i].Active !== undefined) {
        continue;
      }

      this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems[i].DisplayValue = false;
      this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems[i].Active = false;
      this.vueModel.CreateClaimEntity.ProductSpecific.DamagedItems[i].Editable = false;
    }
  },
  methods: {
    toggleField(index) {
      const field = this.damagedItems[index];

      field.Editable = false;
      field.Value = null;
      field.DisplayValue = null;

      // this.resetSingleFieldValidation('damaged-item-value-' + index);
    },
    editDamagedItemValue(index) {
      this.damagedItems[index].Editable = true;

      this.$nextTick(() => {
        const elm = document.getElementById('damaged-item-value-' + index);

        elm.focus();
        elm.setSelectionRange(0, 0);
      });
    },
    updateDisplayValue(index) {
      this.$parent.$parent.validate('damaged-item-value-' + index).then((result) => {
        if (result.results['damaged-item-value-' + index].valid) {
          this.damagedItems[index].DisplayValue =
            this.damagedItems[index].Value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') +
            ' kr.';
          this.damagedItems[index].Editable = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.title {
  display: block;
  font-weight: 700;
}

.label {
  display: block;
  font-weight: 700;
  margin-bottom: rem-calc(5);
}
</style>
